export default __webpack_public_path__ + "static/media/GAN2.f236eade.png";